import React from 'react';
import { Button, Table, InputNumber, Input } from 'antd';
import { PlusOutlined, DeleteOutlined } from '@ant-design/icons';
import type { ColumnsType } from 'antd/es/table';
import { FG113M } from '../../../services/pwg201Api';

interface Props {
  rows: FG113M[];
  isEditing: boolean;
  onChange: (rows: FG113M[]) => void;
}

const WriteoffBorrTab: React.FC<Props> = React.memo(({ rows, isEditing, onChange }) => {
  const addRow = () => {
    onChange([
      ...rows,
      { fg113_01: '', fg113_02: rows.length + 1, fg113_11: '', fg113_12: 'NTD', fg113_13: 0, fg113_14: 0, fg113_90: 0 },
    ]);
  };

  const deleteRow = (idx: number) => onChange(rows.filter((_, i) => i !== idx));

  const updateRow = (idx: number, field: keyof FG113M, value: any) => {
    const updated = [...rows];
    (updated[idx] as any)[field] = value;
    onChange(updated);
  };

  const columns: ColumnsType<FG113M> = [
    { title: <span data-contract-field="fg113_02">序</span>, dataIndex: 'fg113_02', width: 50 },
    {
      title: <span data-contract-field="fg113_11">暫借款單號</span>,
      dataIndex: 'fg113_11',
      render: (v, _, i) =>
        isEditing ? (
          <Input size="small" value={v} onChange={e => updateRow(i, 'fg113_11', e.target.value)} />
        ) : v,
    },
    {
      title: <span data-contract-field="fg113_12">幣別</span>,
      dataIndex: 'fg113_12',
      width: 70,
      render: (v, _, i) =>
        isEditing ? (
          <Input size="small" value={v} maxLength={3} onChange={e => updateRow(i, 'fg113_12', e.target.value)} />
        ) : v,
    },
    {
      title: <span data-contract-field="fg113_13">沖銷金額</span>,
      dataIndex: 'fg113_13',
      width: 120,
      render: (v, _, i) =>
        isEditing ? (
          <InputNumber size="small" value={v} style={{ width: '100%' }} onChange={val => updateRow(i, 'fg113_13', val ?? 0)} />
        ) : v,
    },
    ...(isEditing
      ? [{
          title: '',
          width: 40,
          render: (_: any, __: FG113M, i: number) => (
            <Button type="text" danger icon={<DeleteOutlined />} size="small" onClick={() => deleteRow(i)} />
          ),
        }]
      : []),
  ];

  return (
    <div>
      <Table size="small" columns={columns} dataSource={rows} rowKey={(_, i) => `borr-${i}`} pagination={false} />
      {isEditing && (
        <Button icon={<PlusOutlined />} onClick={addRow} style={{ marginTop: 8 }}>
          新增沖暫借款
        </Button>
      )}
    </div>
  );
});

export default WriteoffBorrTab;
